import React from 'react';
import Header from '@/components/Header';
import PageHero from '@/components/PageHero';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const complianceData = [
  {
    title: "1. Introduction and Regulatory Status",
    content: "ALTA-X, and its associated digital platform ALTA.X.COM, are proprietary products of 1st Group Capital (Pty) Ltd, a private company duly incorporated in the Republic of South Africa. 1st Group Capital (Pty) Ltd is an authorized Financial Services Provider (FSP) with license number 49632, regulated by the Financial Sector Conduct Authority (FSCA) of South Africa. This document outlines the regulatory framework within which we operate and the legal terms governing our services."
  },
  {
    title: "2. Acceptance of Terms",
    content: "By accessing and utilizing the ALTA-X platform, you, the user and investor, hereby acknowledge and agree to be unequivocally bound by the terms and conditions set forth herein. Your engagement with the platform constitutes a legally binding agreement to adhere to this FSCA Compliance Notice, in conjunction with our master Terms of Service and Privacy Policy."
  },
  {
    title: "3. Scope of Financial Services",
    content: "ALTA-X provides intermediary and principal services for investing in Contracts for Difference (CFDs), which provide economic exposure to a variety of underlying alternative and traditional assets. Our services are provided on an execution-only basis. We do not offer financial advice, investment recommendations, or portfolio management services."
  },
  {
    title: "4. Nature of Contracts for Difference (CFDs)",
    content: "A Contract for Difference (CFD) is a derivative instrument where ALTA-X acts as the principal (counterparty) to the contract issued to you, the investor. A CFD allows you to gain economic exposure to the price movements and dividend benefits of an underlying asset without requiring you to own the asset directly. This structure facilitates access to investments that might otherwise be inaccessible."
  },
  {
    title: "5. Acknowledgement of Risk",
    content: "Investing in CFDs carries a significant level of risk and may not be suitable for all investors. The value of your investments can fluctuate, and you may lose some or all of your invested capital. You should not invest money that you cannot afford to lose and should seek independent financial advice if you have any doubts."
  },
  {
    title: "6. No Provision of Financial Advice",
    content: "ALTA-X does not provide any form of financial, legal, or tax advice. All information provided on our platform is for informational purposes only and should not be construed as a recommendation or solicitation to buy, sell, or hold any investment. You are solely responsible for your investment decisions."
  },
  {
    title: "7. Client Fund Protection and Segregation",
    content: "In strict compliance with FSCA regulations, all client funds are held in a segregated trust account with a major, reputable South African banking institution. These funds are maintained entirely separate from the operational capital of 1st Group Capital (Pty) Ltd, ensuring that your capital is protected and not used for company business."
  },
  {
    title: "8. Conflict of Interest Management",
    content: "1st Group Capital (Pty) Ltd maintains a comprehensive Conflict of Interest Management Policy to identify, mitigate, and manage any potential conflicts that may arise between the company, its employees, and its clients. This policy is available upon request and ensures that we act with integrity and fairness in all our dealings."
  },
  {
    title: "9. Anti-Money Laundering (AML) Compliance",
    content: "We are fully committed to complying with the Financial Intelligence Centre Act (FICA) and all applicable anti-money laundering (AML) and counter-terrorist financing (CTF) regulations. This requires us to conduct thorough client due diligence and identity verification procedures before and during our business relationship."
  },
  {
    title: "10. Complaints and Dispute Resolution",
    content: "Should you have a complaint, please submit it in writing to our compliance department at compliance@alta-x.com. We will address your concerns through our internal dispute resolution process. If the matter is not resolved to your satisfaction, you have the right to escalate the complaint to the Office of the FAIS Ombud."
  },
  {
    title: "11. Data Protection and Privacy",
    content: "We are committed to protecting your personal information in accordance with the Protection of Personal Information Act (POPIA). Our Privacy Policy, available on our website, details how we collect, use, and secure your data."
  },
  {
    title: "12. Governing Law and Jurisdiction",
    content: "This agreement and all transactions conducted on the ALTA-X platform are governed by and construed in accordance with the laws of the Republic of South Africa. You hereby consent to the exclusive jurisdiction of the South African courts in respect of any disputes arising from this agreement."
  }
];

const FscaCompliance: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <PageHero 
        title="FSCA Compliance"
        subtitle="Our commitment to regulatory standards and investor protection"
        backgroundImage="https://images.pexels.com/photos/730564/pexels-photo-730564.jpeg"
      />
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible className="w-full">
              {complianceData.map((item, index) => (
                <AccordionItem value={`item-${index + 1}`} key={index}>
                  <AccordionTrigger className="text-left">{item.title}</AccordionTrigger>
                  <AccordionContent className="prose prose-lg max-w-none text-gray-600">
                    {item.content.includes('compliance@alta-x.com') ? 
                      <p>Should you have a complaint, please submit it in writing to our compliance department at <a href="mailto:compliance@alta-x.com" className="text-blue-600 hover:underline">compliance@alta-x.com</a>. We will address your concerns through our internal dispute resolution process. If the matter is not resolved to your satisfaction, you have the right to escalate the complaint to the Office of the FAIS Ombud.</p> 
                      : <p>{item.content}</p>
                    }
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FscaCompliance;
